import { render, staticRenderFns } from "./RemProviderList.vue?vue&type=template&id=7981c638&"
import script from "./RemProviderList.vue?vue&type=script&lang=js&"
export * from "./RemProviderList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports